var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.999 22H4.99902C3.89445 22 2.99902 21.1046 2.99902 20V6C2.99902 4.89543 3.89445 4 4.99902 4H6.99902V2H8.99902V4H14.999V2H16.999V4H18.999C20.1036 4 20.999 4.89543 20.999 6V20C20.999 21.1046 20.1036 22 18.999 22ZM4.99902 10V20H18.999V10H4.99902ZM4.99902 6V8H18.999V6H4.99902Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6dc9eea3.svg";
export { ForwardRef as ReactComponent };